module.exports = __webpack_public_path__ + "media/images/handshake-32-regular-eff5b10e71161f1618852431576b26d1.svg";